import { EnvSetting } from './env-setting';
import { environment } from 'projects/Administration/src/environments/environment';
import * as AfEnv from 'src/environments/environment';

const BaseUrl = environment.ADMIN_API_URL;
const PartsUrl = environment.parts_service_url;
const LocalizationUrl = AfEnv.environment.LOCALIZATION_API_URL;

export const Urls = {
  GetAllDealerDetails: BaseUrl + `Workshop/GetAllDealerDetails`,
  GetAdditionalServices: BaseUrl + `Workshop/GetDealerAdditionalServices`,
  GetCustomerWaitingTime: BaseUrl + 'Appointment/CheckWaitingTime',

  //Service Categories
  GetServiceCategory: BaseUrl + 'ServiceCategories/Get',
  AddUpdateServiceCategory: BaseUrl + 'ServiceCategories/AddUpdate',
  DeleteServiceCategory: BaseUrl + 'ServiceCategories/Delete',
  GetServiceCategoryById: BaseUrl + 'ServiceCategories/GetById',

  //Service
  GetService: BaseUrl + 'Service/Get',
  AddUpdateService: BaseUrl + 'Service/AddUpdate',
  DeleteService: BaseUrl + 'Service/Delete',
  GetServiceById: BaseUrl + 'Service/GetById',
  GetSelectServiceSectionDetails: BaseUrl + 'Service/GetAll',
  GetServiceTimeDetails: BaseUrl + 'Service/GetServiceTimeDetails',
  GetDiagnoseCheckListForService: BaseUrl + 'DiagnoseChecklist/GetDiagnoseCheckListForService',
  
  //Package
  AddPackage: BaseUrl + 'Package/Add',
  GetPackage: BaseUrl + 'Package/Get',
  EditPackage: BaseUrl + 'Package/Edit',
  DeletePackage: BaseUrl + 'Package/Delete',
  GetPackageById: BaseUrl + 'Package/GetById',
  GetPackageList:BaseUrl+'Package/Get',
  GetPackageVersionByPackageNo:BaseUrl+'Package/GetPackageVersionByPackageNo',
  GetPackageBOMByPackageNo:BaseUrl+'Package/GetPackageBOMByPackageNo',
  GetBillOfMaterialType:BaseUrl+'Package/GetBillOfMaterialType',
  GetPackageDetail:BaseUrl+'Package/GetPackageDetails',
  AddUpdatePackage: BaseUrl + 'Package/AddUpdatePackage',
  SearchPackageDetail: BaseUrl + 'Package/Search',
  DeletePackageVersion : BaseUrl + 'Package/DeletePackageVersion',
  DeletePackageByNumber:BaseUrl+'Package/DeletePackageByNumber',
  ResyncPackage:BaseUrl + 'Package/ResyncPackage',
  GetAfxPackageDropdown:BaseUrl + 'Package/GetAfxPackageDropdown',
  GetPackageBOMByDealerServiceId: BaseUrl + 'Package/GetPackageBOMByDealerServiceId',
  DuplicatePackage: BaseUrl + 'Package/DuplicatePackage',

  //AddCustomerVehiclle
  GetCustomerAndVehicleDetails: BaseUrl + 'Vehicle/GetVehicleDetailsForWidget',
  GetCustomerVehiclesByMobileNo: BaseUrl + 'Vehicle/GetCustomerVehiclesByMobileNo',
  GetCustomerListByMobileNo: BaseUrl + 'Vehicle/GetCustomerListByMobileNo',
  GetBrandList: EnvSetting.WIDGET_API_URI + 'Vehicle/GetBrandList',
  GetCountryCodeAndMobileCodeDetails: BaseUrl + 'Vehicle/GetCountryNameAndMobileCodeList',
  GetFuelTypeDetails: BaseUrl + 'Vehicle/GetAllFuelType',
  CheckCustomerAvailable: BaseUrl + 'Vehicle/CheckCustomerAvailable',
  AddCustomerVehicleDetails: BaseUrl + 'Vehicle/AddCustomerVehicleDetails',
  SearchLicensePLate: BaseUrl + 'Vehicle/SearchLicensePLate',
  getVehicleDetailsFromDMSByVehicleno: EnvSetting.WIDGET_API_URI + 'Vehicle/GetVehicleInformationFromDMS',

  //Appointment
  GetDealerRentalCars: BaseUrl + 'Workshop/GetDealerRentalCars',
  GetGenericRentalCars: BaseUrl + 'RentalVehicle/GetGenericRentalCars',
  GetAppointmentList: BaseUrl + 'Appointment/Get',
  UpdateNeedAttention: BaseUrl + 'Appointment/UpdateNeedAttention',
  GetAppointmentStatusList: BaseUrl + 'StatusConfiguration/GetStatus',
  GetAdditionalWorkDetails: BaseUrl + 'Appointment/GetAppointmentWOConfirmationDetail',
  UpdateAppointmentStatus: BaseUrl + 'Appointment/UpdateStatus',
  UpdateOnHoldStatus: BaseUrl + 'Appointment/UpdateOnHoldStatus',
  UpdateAppointmentStatusList: BaseUrl + 'StatusConfiguration/UpdateStatus',
  GetAllStatus: BaseUrl + 'Appointment/GetAllStatus',
  GetOnHoldStatusReasonList :BaseUrl + 'Appointment/GetOnHoldStatusReasonList',
  GetPdfType: BaseUrl + 'Appointment/GetPdfType',
  GetAllWorkOrderStatus: BaseUrl + 'Appointment/GetAllWorkOrderStatus',
  GetAppointmentDetail: BaseUrl + 'Appointment/GetDetail',
  GetAppointmentService: BaseUrl + 'services/GetServiceDetail',
  
  AddCrmAppointment: BaseUrl + 'Appointment/AddCrmAppointment',
  AddAppointment: BaseUrl + 'Appointment/AddAppointment',
  UpdateAppointment: BaseUrl + 'Appointment/UpdateAppointment',
  GetClockinDemandDetails: BaseUrl + 'Appointment/GetClockinDemandDetails',
  UpdateAdditionalWork: BaseUrl + 'Appointment/UpdateAdditionalWork',
  DeleteAppointment: BaseUrl + 'Appointment/DeleteAppointment',
  GetDemandDescription : BaseUrl + 'Appointment/GetDemandDescription',
  GetServiceDetails: BaseUrl + 'services/GetServiceDetail',
  GetInvoiceDetails: BaseUrl + 'Appointment/GetInvoiceDetails',
  GetAdditionalServiceDetails: BaseUrl + 'services/GetAdditionalWorkServiceDetail',
  GetServicesByDealerId: BaseUrl + 'Appointment/GetServicesByDealerId',
  GetStatusBrand: BaseUrl + 'Appointment/GetStatusAndDealerBrand',
  GetActiveAppointmentForVehicle: BaseUrl + 'Appointment/GetActiveAppointmentForVehicle',
  UpdateWorkOrderDetails: BaseUrl + 'Appointment/UpdateAdditionalWorkOrderConfirmation',
  GetActiveWorkOrder: BaseUrl + 'Appointment/GetActiveWorkOrder',
  GetWorkOrderHistoryForVehicle: BaseUrl + 'Appointment/GetWorkOrderHistoryForVehicle',
  GetWidgetAppointmentRequest: BaseUrl + 'ServiceAdvisor/GetWidgetAppointmentRequestList',
  GetWidgetAppointmentDetail: BaseUrl + 'ServiceAdvisor/GetWidgetAppointmentDetail',
  DeleteWidgetAppointment: BaseUrl + 'ServiceAdvisor/DeleteWidgetAppointment',
  ApproveRejectWidgetAppointment: BaseUrl + 'ServiceAdvisor/ApproveRejectWidgetAppointment',
  AddDFDetails: BaseUrl + 'ServiceAdvisor/AddDFDetails',
  getAppointmentStatusList: BaseUrl + 'ServiceAdvisor/getAppointmentStatusList',
  UpdateWidgetAppointmentVehicleDetail: BaseUrl + 'ServiceAdvisor/UpdateWidgetAppointmentVehicleDetail',
  ResyncAppointment: BaseUrl + 'Appointment/Resync',
  GetAppointmentDayList: BaseUrl + 'Appointment/GetAppointmentDayList',
  GetUpdateAppointmentHistory: BaseUrl + 'Appointment/GetHistory',
  AddAppointmentJobPackageInDms: BaseUrl + 'Appointment/AddAppointmentJobPackageInDms',
  ShiftAppointment: BaseUrl + 'Appointment/ShiftAppointment',
  RefreshCustomerData: BaseUrl + 'Appointment/RefreshCustomerData',
  RefreshVehicleData: BaseUrl + 'Appointment/RefreshVehicleData',
  SyncDemandToSST: BaseUrl + 'Appointment/SyncDemandToSST',
  GetCustomerWithMobile:BaseUrl + 'Appointment/GetCustomerWithMobile',
  
  //ArchivedAppointment
  GetArchivedAppointmentList: BaseUrl + 'ArchivedAppointment/Get',
  GetAllStatusForArchivedAppointments: BaseUrl + 'ArchivedAppointment/GetAllStatus',
  GetAllWorkOrderStatusForArchivedAppointments: BaseUrl + 'ArchivedAppointment/GetAllWorkOrderStatus',
  DeleteArchivedAppointment: BaseUrl + 'ArchivedAppointment/DeleteArchivedAppointment',

   
   
  AddAppointmentAsQuoteFromRejectedDemand: BaseUrl + 'Appointment/AddAppointmentAsQuoteFromRejectedDemand',
  SplitDemandsFromExistingAppointment: BaseUrl + 'Appointment/SplitDemandsFromExistingAppointment',
  UploadDocumentFromPlanner:BaseUrl + 'UploadDocument/UploadDocumentFromPlanner',
  MoveRequestForJobDetails: BaseUrl +'Appointment/MoveRequestForJobDetails',
  GetDeamandWiseDocumentCount:BaseUrl + 'Appointment/GetDemandWiseDocumentCount',
  GetDemandWiseDocuments:BaseUrl + 'Appointment/GetDemandWiseDocuments',
  GetDemandViewFile: BaseUrl + 'GetDemandViewFile',
  GetDemandDownloadFile: BaseUrl + 'GetDemandDownloadFile',

  //AdvanceSearch
  SaveAdvanceSearchFilter: BaseUrl + 'AdvanceSearch/Save',
  GetAdvanceSearchList: BaseUrl + 'AdvanceSearch/Get',
  DeleteAdvanceSearch: BaseUrl + 'AdvanceSearch/Delete',

  GetServicesList: BaseUrl + 'Service/Get',
  //Appointment Schedule
  GetAppointmentSchedule: BaseUrl + 'AppointmentPlanning/GetMechanicScheduler',
  SaveAppointmentPlanning: BaseUrl + 'AppointmentPlanning/SaveAppointmentPlanning',
  SaveSplitBooking: BaseUrl + 'AppointmentPlanning/GetSplitBooking',
  DeleteAppointmentBooking: BaseUrl + 'AppointmentPlanning/DeleteAppointmentBooking',
  UpdateAppointmentPlanningTime: BaseUrl + 'AppointmentPlanning/UpdateAppointmentPlanningTime',
  UpdateAppointmentPlanning: BaseUrl + 'AppointmentPlanning/UpdateAppointmentPlanning',
  GetMechanicMonthwiseDetails: BaseUrl + 'AppointmentPlanning/GetMechanicPlannedAndAvailableHours',
  GetWeekData: BaseUrl + 'AppointmentPlanning/GetWeekViewData',
  GetMEchanicSchedulePlanningMenu: BaseUrl + 'AppointmentPlanning/GetMechanicSchedulerPlanningMenu',
  GetScheduleSummaryPlanningMenu: BaseUrl + 'AppointmentPlanning/GetScheduleSummaryPlanningMenu',
  // GetMechanicClockingTime: BaseUrl + 'AppointmentPlanning/GetMechanicClockingTime',
  GetMechanicInOutOverTime: BaseUrl + 'AppointmentPlanning/GetMechanicInOutOverTime',
  GetMechanicInOutSummary: BaseUrl + 'AppointmentPlanning/GetMechanicInOutSummary',
  GetWeekViewPlanning:BaseUrl + 'Appointment/GetWeekViewPlanning',
  GetWOMechanicForPlanning: BaseUrl + 'AppointmentPlanning/GetWOMechanicForPlanning',
  GetMechanicJobListForWO:BaseUrl + 'AppointmentPlanning/GetMechanicJobListForWO',
  SaveMechanicBlockedSlot: BaseUrl + 'AppointmentPlanning/BlockMechanicSlot',
  DeleteBlockedMechanicSlot: BaseUrl + 'AppointmentPlanning/DeleteBlockedMechanicSlot',
  UpdateMechanicBlockedSlot: BaseUrl + 'AppointmentPlanning/UpdateBlockedMechanicSlot',
  GetServiceCampaignOption : BaseUrl + 'Appointment/GetServiceCampaignOption',
  
  //Mechanic
  GetMechanicList: BaseUrl + 'Mechanic/Get',
  AddMechanic: BaseUrl + 'Mechanic/Add',
  GetMechanicById: BaseUrl + 'Mechanic/GetById',
  UpdateMechanic: BaseUrl + 'Mechanic/Update',
  ResyncMechanic: BaseUrl + 'Mechanic/Resync',
  ValidateDmsMechanicId: BaseUrl + 'Mechanic/ValidateDmsMechanicId',

  //SMSLog
  GetSMSLogList: BaseUrl + 'SMSLog/Get',

  //DMS Sync Failed Log
  GetDmsSyncFailedLog: BaseUrl + 'DmsSyncFailedLog/Get',

  //Error Log
  GetSmartPlannerExceptionLog: BaseUrl + 'SmartPlannerExceptionLog/Get',

  //Dms Sync Queue Log

  GetDmsSyncQueueLog: BaseUrl + 'DmsSyncQueueLog/GetDmsSyncQueueLogList',
  DeleteDMSSyncQueue: BaseUrl + 'DmsSyncQueueLog/DeleteDMSSyncQueue',

  //AFX Sync Failed Log

  GetAfxSyncFailedLog: BaseUrl + 'AfxSyncFailedLog/GetAfxSyncFailedLogList',
  GetModuleNamesList:BaseUrl + 'AfxSyncFailedLog/GetModuleNamesList',

  //MechanicCompetence
  AddEditMechanicCompetence: BaseUrl + 'MechanicCompetence/AddEditMechanicCompetence',
  GetMechanicCompetenceByMechanicId: BaseUrl + 'MechanicCompetence/GetByMechanicId',

  //Mechanic Opening Hours
  GetMechanicOpeningHoursById: BaseUrl + 'MechanicShift/GetMechanicShiftDetailsbyId',
  GetDealerMechanicLunchShiftDetails: BaseUrl + 'DealerMechanicLunchShift/GetDealerMechanicLunchShiftDetails',
  UpdateMechanicOpeningHours: BaseUrl + 'MechanicShift/UpdateMechanicShiftDetails',


  //MechanicLeaves
  GetMechanicLeavesList: BaseUrl + 'MechanicHoliday/GetMechanicHolidaybyId',
  AddMechanicLeaves: BaseUrl + 'MechanicHoliday/AddMechanicLeave',
  GetMechanicLeavebyId: BaseUrl + 'MechanicHoliday/GetMechanicLeavebyId',
  UpdateMechanicLeaves: BaseUrl + 'MechanicHoliday/EditMechanicLeave',
  DeleteLeave: BaseUrl + 'MechanicHoliday/DeleteMechanicLeave',
  GetList: BaseUrl + 'MechanicRecipient/Get',

  //Rentalcar
  GetRentalCarList: BaseUrl + 'RentalVehicle/Get',
  AddRentalCar: BaseUrl + 'RentalVehicle/Add',
  EditRentalCar: BaseUrl + 'RentalVehicle/Update',
  GetRentalCarById: BaseUrl + 'RentalVehicle/GetById',
  DeleteRentalCar: BaseUrl + 'RentalVehicle/Delete',
  GetFuelTypes: BaseUrl + 'Vehicle/GetAllFuelType',
  GetBrand: EnvSetting.WIDGET_API_URI + 'Vehicle/GetBrandList',
  GetAllVehicleStatus: BaseUrl + 'Vehicle/GetAllVehicleStatus',

  // Dealer Service
  GetDealerServiceList: BaseUrl + 'DealerService/Get',
  GetDealerServiceDetails: BaseUrl + 'DealerService/Details',
  DeleteDealerService: BaseUrl + 'DealerService/Delete',
  AddDealerService: BaseUrl + 'DealerService/Add',
  EditDealerService: BaseUrl + 'DealerService/Update',
  GetDealerServiceTimeDetails: BaseUrl + 'DealerService/GetDealerServiceTimeDetails',

  //Language
  GetAllLanguages: LocalizationUrl + 'Localization/Languages',
  GetLocalizationData: BaseUrl + 'Localization/GetData',
  GetAllLanguage: BaseUrl + 'Localization/Get',
  GetClientIpDetail: BaseUrl + 'Localization/GetIpDetail',
  AddIpDetail: BaseUrl + 'Localization/Add',

  //Dealer
  GetCountries: BaseUrl + 'Dealer/GetAllCountries',
  GetDealerList: BaseUrl + 'Dealer/Get',
  GetDealerBrandList: BaseUrl + 'Brand/GetList',
  GetDealerNotificationList: BaseUrl + 'Notification/DealerNotificationDetails',
  GetMyRecipientList: BaseUrl + 'Notification/GetUsersRecipient',
  GetManualNotificationData: BaseUrl + 'Notification/GetManualNotificationData',
  ConfirmAppointmentEmail: BaseUrl + 'Notification/ConfirmAppointmentEmail',
  DeleteDealer: BaseUrl + 'Dealer/Delete',
  GetDealerDetails: BaseUrl + 'Dealer/Details',
  UpdateDealerDetails: BaseUrl + 'Dealer/Update',
  AddRecipient: BaseUrl + 'Notification/AddUserRecipients',
  SendNotification: BaseUrl + 'Notification/SendManualNotification',
  AddToNotification: BaseUrl + 'Notification/AddRecipientToAppointmentNotification',
  AddDealerDetails: BaseUrl + 'Dealer/Add',
  AddDealerCommunicationDetails: BaseUrl + 'Dealer/AddCommunicationDetails',
  AddDealerBrand: BaseUrl + 'Dealer/AddBrand',
  EditDealerBrand: BaseUrl + 'Dealer/EditDealerBrand',
  DeleteDealerBrand: BaseUrl + 'Dealer/DeleteDealerBrand',
  GetDealerWorkingHoursAndHoliday: BaseUrl + 'Dealer/GetDealerWorkingHoursAndHoliday',
  GetUserDealersDropdown: BaseUrl + 'Dealer/user-dealer-dropdown',
  GetLocationCode: BaseUrl + 'Locationcode/locationcode',
  GetNotificationPreview: BaseUrl + 'Notification/GetNotificationPreview',

  //OLB Dealers
  OlbGetDealers: BaseUrl + 'Dealer/OlbGetDealers',
  OlbGetDealerDetail: BaseUrl + 'Dealer/OlbGetDealerDetail',
  OlbGetDealerConfig: BaseUrl + 'Dealer/OlbGetDealerConfig',
  ResyncDealer: BaseUrl + 'Dealer/Resync',

  //Reception
  AddUpdateUser: BaseUrl + 'Reception/AddUpdate',
  GetUserList: BaseUrl + 'Reception/GetUserList',
  GetUserDetail: BaseUrl + 'Reception/Details',
  DeleteUser: BaseUrl + 'Reception/Delete',
  GetCreatedByUser: BaseUrl + 'Appointment/GetCreatedByUser',

  //User WorkingHours
  UserAddEditSpecialOccasion:BaseUrl + 'UserWorkingHours/AddEditSpecialOccasion',
  UserSpecialOccasionList:BaseUrl+'UserWorkingHours/GetSpecialOccasionList',
  GetUserWorkingHours: BaseUrl + 'UserWorkingHours/Get',
  UpdateUserWorkingHours: BaseUrl + 'UserWorkingHours/Update',
  GetUserLunchShiftDetails: BaseUrl + 'UserWorkingHours/GetUserLunchShiftDetails',
  UserDeleteSpecialOccasion:BaseUrl+'UserWorkingHours/DeleteSpecialOccasion',
  AddUserLeaves: BaseUrl + 'UserWorkingHours/AddUserLeave',
  GetUserleaveById : BaseUrl + 'UserWorkingHours/GetUserLeavebyId',
  GetUserLeaveList : BaseUrl + 'UserWorkingHours/GetUserLeaveList',
  UpdateUserLeaves: BaseUrl + 'UserWorkingHours/EditUserLeave',
  DeleteUserLeave: BaseUrl + 'UserWorkingHours/DeleteUserLeave',

  //Dealer WorkingHours
  GetDealerWorkingHours: BaseUrl + 'DealerWorkingHours/Get',
  UpdateDealerWorkingHours: BaseUrl + 'DealerWorkingHours/Update',
  AddEditSpecialOccasion:BaseUrl + 'DealerWorkingHours/AddEditSpecialOccasion',
  GetSpecialOccasionList:BaseUrl+'DealerWorkingHours/GetSpecialOccasionList',
  DeleteSpecialOccasion:BaseUrl+'DealerWorkingHours/DeleteSpecialOccasion',
  GetNextAvailbleStatus: BaseUrl + 'DealerWorkingHours/GetNextAvailableStatus',
  GetDealerLunchShiftDetails: BaseUrl + 'DealerWorkingHours/GetDealerLunchShiftDetails',

  //TechnicalManual
  GetTechnicalList: BaseUrl + 'TechnicalManual/Get',
  DeleteTechnicalManual: BaseUrl + 'TechnicalManual/Delete',
  GetTechnicalManual: BaseUrl + 'TechnicalManual/GetById',
  AddtechnicalManual: BaseUrl + 'TechnicalManual/Add',
  EditTechnicalManual: BaseUrl + 'TechnicalManual/Edit',

  //SpecialTool
  GetSpecialToolList: BaseUrl + 'SpecialTool/Get',
  DeleteSpecialTool: BaseUrl + 'SpecialTool/Delete',
  GetSpecialTool: BaseUrl + 'SpecialTool/GetById',
  AddEditSpecialToolList: BaseUrl + 'SpecialTool/AddEdit',
  GetAllSpecialToolType: BaseUrl + 'SpecialTool/GetSpecialToolType',

  //Preference
  GetPreferenceList: BaseUrl + 'Preference/Get',
  DeletePreference: BaseUrl + 'Preference/Delete',
  ActiveInactivePreference: BaseUrl + 'Preference/ActiveInactive',
  GetPreference: BaseUrl + 'Preference/GetById',
  AddEditPreference: BaseUrl + 'Preference/AddEdit',
  ActiveInActiveDealerForPreference: BaseUrl + 'Preference/ActiveInActiveDealer',
  GetAllActiveDealerForPreference: BaseUrl +  'Preference/GetAllActiveDealer',
  //Category
  GetCategoryList: BaseUrl + 'Category/Get',
  DeleteCategory: BaseUrl + 'Category/Delete',
  ActiveInactiveCategory: BaseUrl + 'Category/ActiveInactive',
  GetCategory: BaseUrl + 'Category/GetById',
  AddEditCategory: BaseUrl + 'Category/AddEdit',

  //Promotion
  GetPromotionList: BaseUrl + 'Promotion/Get',
  DeletePromotion: BaseUrl + 'Promotion/Delete',
  ActiveInactivePromotion: BaseUrl + 'Promotion/ActiveInactive',
  GetPromotion: BaseUrl + 'Promotion/GetById',
  AddEditPromotion: BaseUrl + 'Promotion/AddEdit',
  ActiveInActiveDealerForPromotion: BaseUrl + 'Promotion/ActiveInActiveDealer',
  GetAllActiveDealerForPromotion: BaseUrl +  'Promotion/GetAllActiveDealer',

  //DealerSpecialTool
  GetDealerSpecialToolList: BaseUrl + 'DealerSpecialTool/Get',
  GetDealerSpecialTool: BaseUrl + 'DealerSpecialTool/GetById',
  EditDealerSpecialTool: BaseUrl + 'DealerSpecialTool/Edit',
  GetPartNumberList: BaseUrl + 'DealerSpecialTool/GetByBrandId',
  AssignDealerSpecialTool: BaseUrl + 'DealerSpecialTool/Add',

  //Vehicle
  GetVehicleServiceList: BaseUrl + 'Vehicle/GetList',
  GetVehicleById: BaseUrl + 'Vehicle/GetVehicleById',
  EditVehicle: BaseUrl + 'Vehicle/Update',
  GetVehicleByLicensePlateNo: BaseUrl + 'Vehicle/GetVehicleByLicensePlateNo',
  GetVehicleOwnerTypeDropdownList: BaseUrl + 'VehicleOwnerType/GetVehicleOwnerTypeDropdownList',
  GetVehicleTransmissionDropdownList: BaseUrl + 'VehicleTransmission/GetVehicleTransmissionDropdownList',
  AddEditVehicle: BaseUrl + 'Vehicle/AddEdit',
  CrmAddEditVehicle: BaseUrl + 'Vehicle/CrmAddEdit',
  GetVehicleByCustomerId: BaseUrl + 'Vehicle/GetVehicleByCustomerId',
  UnmapCustomerVehicle: BaseUrl + 'Vehicle/UnmapCustomerVehicle',
  GetCustomerDetailByVehicleId: BaseUrl + 'Vehicle/GetCustomerDetail',
  UpdateVehicleCustomer: BaseUrl + 'Vehicle/UpdateVehicleCustomer',
  UpdateVehicleCustomerMapping: BaseUrl + 'Vehicle/UpdateVehicleCustomerMapping',
  ResyncVehicle: BaseUrl + 'Vehicle/Resync',
  HardDeleteVehicle: BaseUrl + 'Vehicle/HardDeleteVehicle',
  DeleteVehicle: BaseUrl + 'Vehicle/DeleteVehicle',
  SearchCustomerThroughDF: BaseUrl + 'Vehicle/GetDFCustomerDetails',

  VehicleInformation: BaseUrl + 'VehicleInformation/vehicleinformation',
  GetVehicleOwnershipHistory: BaseUrl + 'Vehicle/GetVehicleOwnershipHistory',
  //Dealer Holiday
  GetDealerHolidayList: BaseUrl + 'DealerHoliday/Get',
  GetDealerWiseHolidayList: BaseUrl + 'DealerHoliday/GetDealer',
  AddDealerHoliday: BaseUrl + 'DealerHoliday/Add',
  EditDealerHoliday: BaseUrl + 'DealerHoliday/Update',
  DealerHolidayDetails: BaseUrl + 'DealerHoliday/Details',
  DeleteDealerHoliday: BaseUrl + 'DealerHoliday/Delete',

  //DWO CheckList Management
  GetCheckList: BaseUrl + 'Checklist/GetCheckList',
  AddCheckList: BaseUrl + 'Checklist/SaveCheckListGroupDetails',
  AddCheckListItem: BaseUrl + 'Checklist/SaveCheckListGroupItemDetails',
  DeleteCheckList: BaseUrl + 'Checklist/DeleteSubCheckListItem',
  GetCheckListByMappingId: BaseUrl + 'CheckList/GetCheckListByMappingId',
  UpdateCheckList: BaseUrl + 'CheckList/Update',
  CreateDuplicateCheckList: BaseUrl + 'CheckList/CreateDuplicate',
  GetCheckListItemsByMappingId: BaseUrl + 'CheckList/GetCheckListItemsByMappingId',
  GetColorCheckListItemsByMappingId: BaseUrl + 'CheckList/GetColorCheckListItemsByMappingId',
  UpdateCheckListItem: BaseUrl + 'CheckList/UpdateCheckListGroupItemDetails',
  GetVehicleType: BaseUrl + 'CheckList/GetVehicle',

  //DiagnoseCheck List
  GetDiagnoseCheckList: BaseUrl + 'DiagnoseCheckList/Get',
  AddDiagnoseCheckList: BaseUrl + 'DiagnoseCheckList/Add',
  GetDiagnoseCheckListByMappingId: BaseUrl + 'DiagnoseCheckList/GetByMappingId',
  EditDiagnoseCheckList: BaseUrl + 'DiagnoseCheckList/Edit',
  GetServicesForDiagnoseChecklist: BaseUrl + 'Service/GetServicesForDiagnoseChecklist',

  //Mechanic time Code
  GetMechanicTimeCodeList: BaseUrl + 'MechanicTimeCode/Get',
  AddMechanicTimeCode: BaseUrl + 'MechanicTimeCode/Add',
  GetMechanicTimeCodeById: BaseUrl + 'MechanicTimeCode/GetbyId',
  EditMechanicTimeCode: BaseUrl + 'MechanicTimeCode/Edit',
  

  //DealerParking
  GetDealerParkingDetails: BaseUrl + 'DealerParkingImage/Get',
  AddDealerParkingImage: BaseUrl + 'DealerParkingImage/Add',

  //parts
  AddParts: PartsUrl + 'Parts/AddUpdate',
  GetDealerListForPart: BaseUrl + 'Parts/Get',
  GetPartsList: BaseUrl + 'Parts/GetPartsList',
  GetPartById: PartsUrl + 'Parts/GetPartsById',
  SearchDealerParts: BaseUrl + 'Parts/SearchDealerParts',
  GetPartSalesPriceCalculation: BaseUrl + 'Parts/GetPartSalesPriceCalculation',
  GetLaborChargingGroupPrice: BaseUrl + 'Parts/GetLaborChargingGroupPrice',

  //DealerParts
  GetDealerPartsListById: BaseUrl + 'DealerParts/Get',
  AddDealerParts: PartsUrl + 'DealerParts/AddUpdate',
  GetDealerPartById: PartsUrl + 'DealerParts/GetDealerPartsById',
  UpdateDealerParts: PartsUrl + 'DealerParts/AddUpdate',
  GetDealerPartsSearch: PartsUrl + 'DealerParts/GetDealerParts',

  GetParts: PartsUrl + 'Parts/GetParts',
  GetPartLocation: PartsUrl + 'Parts/GetPartLocations',
  GetAdditionalParts: PartsUrl + 'Parts/GetAdditionalParts',
  GetAlternativeParts: PartsUrl + 'Parts/GetAlternativeParts',
  GetReplacementParts: PartsUrl + 'Parts/GetReplacementParts',
  GetFinalPartsWithAdditional: PartsUrl + 'Parts/GetFinalPartsWithAdditional',
  GetInventoryParts: PartsUrl + 'Parts/GetInventoryParts',
  GetPartDetails: PartsUrl + 'Parts/GetPartDetails',
  GetMultiInventoryParts: PartsUrl + 'Parts/GetMultiInventoryParts',
  GetPartCostPriceDetails: PartsUrl + 'Parts/GetPartCostPriceDetails',

  //DiagnoseTemplate
  GetDiagnoseTemplates: BaseUrl + 'DiagnoseTemplate/Get',
  AddDiagnoseTemplate: BaseUrl + 'DiagnoseTemplate/Add',
  GetDiagnoseTemplateById: BaseUrl + 'DiagnoseTemplate/GetById',
  EditDiagnoseTemplate: BaseUrl + 'DiagnoseTemplate/Edit',
  DeleteDiagnoseTemplate: BaseUrl + 'DiagnoseTemplate/Delete',

  //DWO-CheckList
  GetDwoCheckList: BaseUrl + 'AppointmentCheckList/Get',

  //DWO-Documents
  GetAppointmentFiles: BaseUrl + 'DwoAppointmentFile/Get',
  DeleteDocument: BaseUrl + 'Document/Delete',

  //e-Signature Documents
  DeliveryNoteDownload: BaseUrl + 'Document/DeliveryNoteDownload',
  WarrantyDocumentDownload: BaseUrl + 'Document/WarrantyDocumentDownload',
  WarrantyDocumentSend: BaseUrl + 'Document/WarrantyDocumentSend',
  WarrantyDocumentDownloadSigned: BaseUrl + 'Document/WarrantyDocumentDownloadSigned',
  WarrantyDocumentStatus: BaseUrl + 'Document/WarrantyDocumentStatus',
  GetPendingSignDocument: BaseUrl + 'Document/GetPendingSignDocument',
  OrderDocumentDownload: BaseUrl + 'Document/OrderDocumentDownload',

  //Notification-Communication
  GetNotificationList: BaseUrl + 'Notification/AllTemplateList',
  GetCustomerCommList: BaseUrl + 'Notification/GetCustomerCommList',
  GetAppointmentCommList: BaseUrl + 'Notification/GetAppointmentCommList',
  
  //Template
  TemplateList: BaseUrl + 'Template/List',
  GetTemplate: BaseUrl + 'Template/Get',
  AddTemplate: BaseUrl + 'Template/Add',
  UpdateTemplate: BaseUrl + 'Template/Update',
  GetLanguages: BaseUrl + 'Template/GetLanguages',
  GetDetailsWithCulture: BaseUrl + 'Template/Details',

  //DWO-comments
  GetAppointmentDemandComments: BaseUrl + 'DwoAppointmentFile/GetDemandComments',
  GetAppointmentComments: BaseUrl + 'DwoAppointmentFile/GetComments',
  AddInternalComments: BaseUrl + 'DwoAppointmentFile/Add',
  DeleteInternalComments: BaseUrl + 'DwoAppointmentFile/Delete',
  EditInternalComments: BaseUrl + 'DwoAppointmentFile/Edit',
  EditMediaVisibility: BaseUrl + 'DwoAppointmentFile/EditMediaVisibility',
  DownloadFile: BaseUrl + 'Document/DownloadFile',

  //Appointment-parking
  GetAppointmentParkingImage: BaseUrl + 'DwoAppointmentFile/GetImage',

  //Dealer KeyDrop location
  GetKeyDopLocation: BaseUrl + 'KeyDropLocation/Get',
  GetKeyDopLocationById: BaseUrl + 'KeyDropLocation/GetById',
  AddKeyDopLocation: BaseUrl + 'KeyDropLocation/Add',
  UpdateKeyDopLocation: BaseUrl + 'KeyDropLocation/Update',
  DeleteKeyDopLocation: BaseUrl + 'KeyDropLocation/Delete',
  GetLocationList: BaseUrl + 'KeyDropLocation/GetLocation',

  //Time stamp
  GetSummaryDetails: BaseUrl + 'StampInOut/GetSummaryDetails',
  GetMechanicTimeCodes: BaseUrl + 'StampInOut/GetMechanicTimeCodes',
  MechanicStampIn: BaseUrl + 'StampInOut/MechanicStampIn',
  MechanicStampOut: BaseUrl + 'StampInOut/MechanicStampOut',
  GetMechanicInOutDetails: BaseUrl + 'StampInOut/GetMechanicInOutDetails',
  StopTimeCodeTimer: BaseUrl + 'StampInOut/StopTimeCodeTimer',
  StartTimeCodeTimer: BaseUrl + 'StampInOut/StartTimeCodeTimer',
  GetTimeCodeDetails: BaseUrl + 'StampInOut/GetTimeCodeDetails',
  GetMechanicStampInOutDetails: BaseUrl + 'StampInOut/GetMechanicInOutDetails',
  GetCurrentWO: BaseUrl + 'StampInOut/GetCurrentWO',
  StartWorkOrderTimer: BaseUrl + 'StampInOut/StartWorkOrderTimer',
  UpdateMechanicStampOut: BaseUrl + 'StampInOut/StampOutForMechanic',
  StopWorkOrderTimer: BaseUrl + 'StampInOut/StopWorkOrderTimer',
  StartJobTimer: BaseUrl + 'StampInOut/StartJobTimer',
  StopJobTimer: BaseUrl + 'StampInOut/StopJobTimer',
  GetJobsByWO: BaseUrl + 'StampInOut/GetJobsByWO',
  GetWOSummary: BaseUrl + 'StampInOut/GetWOSummary',
  GetWorkOrderList: BaseUrl + 'StampInOut/GetWorkOrderList',
  GetWorkOrderDetail: BaseUrl + 'StampInOut/GetWorkOrderSummary',
  GetTimeStampSummary: BaseUrl + 'StampInOut/TimeStampSummary',
  UpdateJobStatus:BaseUrl + 'StampInOut/UpdateJobStatus',
  DeleteSummaryDetails: BaseUrl + 'StampInOut/DeleteSummaryDetails',
  EditSummaryDetails: BaseUrl + 'StampInOut/EditSummaryDetails',
  CheckTimerDetails: BaseUrl + 'StampInOut/CheckTimer',
  CheckMechanicTimeDetails: BaseUrl + 'StampInOut/CheckMechanicTimeDetails',
  EditClockingDetails: BaseUrl + 'StampInOut/EditClockingDetails',
  GetJobDetailByWO: BaseUrl + 'StampInOut/GetJobDetailByJobId',
  StartJobDetailTimer: BaseUrl + 'StampInOut/StartJobDetailTimer',
  StopJobDetailTimer: BaseUrl + 'StampInOut/StopJobDetailTimer',

  //Tax
  GetTaxPercentages: BaseUrl + 'Tax/Get',
  UpdatetaxPercentages: BaseUrl + 'Tax/Update',
  //Setting
  GetCurrency: BaseUrl + 'Setting/Get',
  GetSelectedCountry: BaseUrl + 'Setting/GetSelectedCountry',
  GetCountry: BaseUrl + 'Setting/Getcountry',
  UpdateSelectedCountry: BaseUrl + 'Setting/UpdateSelectedCountry',
  GetFieldConfiguration: BaseUrl + 'Setting/getfieldsconfiguration',
  GetSetting: BaseUrl + 'Setting/GetSetting',
  GetSettings: BaseUrl + 'Setting/GetSettings',
  GetCountryWithCode: BaseUrl + 'Setting/GetCountries',
  
  //SyncJob
  GetSyncJobList: BaseUrl + 'SyncJob/GetSyncJobList',
  TriggerJob: BaseUrl,

  //DWO-Diagnose
  GetDiagnoseDemandList: BaseUrl + 'DwoDiagoseList/Get',
  GetDemandDetails: BaseUrl + 'DwoDiagoseList/GetJobDiagnoseCauseReasonList',
  GetDiagnoseCauseReason: BaseUrl + 'DwoDiagoseList/GetDiagnoseCauseReasonList',
  // GetJobDiagnoseCauseList: BaseUrl + 'DwoDiagoseList/GetJobDiagnoseCauseReasonList',
  // GetDiagnoseCauseList: BaseUrl + 'DwoDiagoseList/GetDiagnoseCauseReasonList',
  SaveJobDiagnoseCauseReason: BaseUrl + 'DwoDiagoseList/SaveJobDiagnoseCauseReason',
  SaveCheckList: BaseUrl + 'DwoDiagoseList/SaveCheckList',

  //SST
  GetInspectionsOperationsDetails : BaseUrl + 'SuperServiceTriage/GetInspectionOperations',

  //AutoKey
  GetAutoKeyListByDealer: BaseUrl + 'KeyLocation/GetById',
  GetWorkOrderDetails: BaseUrl + 'KeyLocation/GetAppointmentByDealerIdAndDate',
  GetAvailableLockers : BaseUrl + 'KeyLocation/GetAvailableLockers',
  ReserveLocker : BaseUrl + 'KeyLocation/ReserveLocker',
  GetAutoKeyDetail : BaseUrl + 'KeyLocation/GetAutoKeyDetail',
  ResetLocker: BaseUrl + 'KeyLocation/ResetAutoKeyLocker',
  OpenLocker : BaseUrl + 'KeyLocation/OpenLocker',
  GetShareboxLogData: BaseUrl + 'KeyLocation/GetShareBoxLogData',
  GetAppointmentByDealerIdAndAppointmentId: BaseUrl + 'KeyLocation/GetFinalInvoiceDetailbyAppointmentId',
  AssignLockerToOrder: BaseUrl+'KeyLocation/AssignLockerToOrder',
  GetActiveReservationList: BaseUrl + 'KeyLocation/GetActiveReservationList',

  //DMS Default Values
  GetDMSDefaultValues: BaseUrl + 'Dmsdefaultvalues/dmsDefaultvalue',
  GetDMSName: BaseUrl + 'Dmsdefaultvalues/dmsName',
  GetTableName: BaseUrl + 'Dmsdefaultvalues/tableName',
  AddDMSDefaultValues: BaseUrl + 'Dmsdefaultvalues/add',
  UpdateDMSDefaultValues: BaseUrl + 'Dmsdefaultvalues/edit',
  DeleteDefaultDMSValues: BaseUrl + 'Dmsdefaultvalues/delete',
  FilterDMSValue: BaseUrl + 'Dmsdefaultvalues/FilterDMSValue',
  //Dashboard
  GetCardCount: BaseUrl + 'Dashboard/GetCardCounts',
  GetDealers: BaseUrl + 'Dashboard/GetDealers',
  GetSyncCount:BaseUrl + 'Dashboard/GetSyncCounts',
  GetBrandWiseAppointment:BaseUrl + 'Dashboard/GetBrandWiseAppointment',
  GetDealerWithNoAppointments:BaseUrl + 'Dashboard/GetDealerWithNoAppointments',

  //Caller
  GetCallerInfo: BaseUrl + 'Caller/GetCallerInfo',
  GetCallerVehicle: BaseUrl + 'Caller/GetCallerVehicle',
  GetCallHistory: BaseUrl + 'Caller/GetCallHistory',
  AddCallHistory: BaseUrl + 'Caller/AddCallHistory',
  SaveCallNote: BaseUrl + 'Caller/SaveCallNote',
  CallDial: BaseUrl + 'Caller/CallDial',
  CallTransfer: BaseUrl + 'Caller/CallTransfer',
  CallHangup: BaseUrl + 'Caller/CallHangup',
  UpdateCallEnd: BaseUrl + 'Caller/UpdateCallEnd',
  UpdateCallEndAll: BaseUrl + 'Caller/UpdateCallEndAll',

  //Status Configuration
  GetStatusConfiguration: BaseUrl + 'StatusConfiguration/Get',
  UpdateStatusConfiguration: BaseUrl + 'StatusConfiguration/Update',
  //Customer
  GetCustomerById: BaseUrl + 'Customer/GetById',
  GetCustomerDealerAssociation: BaseUrl + 'Customer/GetCustomerDealerAssociation',
  GetCutomerList: BaseUrl + 'Customer/Get',
  GetVehicleList: BaseUrl + 'Customer/GetVehicle',
  AddCustomerDiscount: BaseUrl + 'Customer/AddDiscount',
  AddEditCustomer: BaseUrl + 'Customer/AddEdit',
  CrmAddEditCustomer: BaseUrl + 'Customer/CrmAddEdit',
  GetCustomerGroupDropdown: BaseUrl + 'CustomerGroup/customerGroupDropdown',
  GetAddressSalutationDropdown: BaseUrl + 'AddressSalutation/addressSalutationDropdown',
  GetPostCodeDropdown: BaseUrl + 'Postcode/postcodeDropdown',
  CheckDuplicateCustomer: BaseUrl + 'Customer/CheckDuplicateCustomer',
  ResyncCustomer: BaseUrl + 'Customer/Resync',
  getDFCustomerListByFullSearch: BaseUrl + 'Customer/getDFCustomerListByFullSearch',
  getDFCustomerListByAdvanceSearch: BaseUrl + 'Customer/getDFCustomerListByAdvanceSearch',
  getEMCustomerListByAdvanceSearch: BaseUrl + 'Customer/getEMCustomerListByAdvanceSearch',
  getAccountsSearchTerm: BaseUrl + 'Customer/getaccountdropdownsearch',
  GetCallHistoryList: BaseUrl + 'Customer/GetCallHistoryList',
  HardDeleteCustomer: BaseUrl + 'Customer/HardDeleteCustomer',
  GetCustomerDropdownByLicensePlateNo: BaseUrl + 'Customer/GetCustomerDropdownByLicensePlateNo',
  GetCustomerHistory: BaseUrl + 'Customer/GetCustomerHistory',
  //CustomerPrivacyLog
  GetCustomerPrivacyLogById: BaseUrl + 'CustomerPrivacyLog/GetCustomerPrivacyLogById',
  //Check Customer Mobile Number
  CheckMobileNo: BaseUrl + 'Customer/CheckMobileNo',
  
  GetCheckInUrl: BaseUrl + 'AppLink/GetCheckInUrl',
  AddTrackerLink: BaseUrl + 'AppLink/AddTrackerLink',
  GetTrackerLink: BaseUrl + 'AppLink/GetTrackerLink',
  SendTrackerSms: BaseUrl + 'AppLink/SendTrackerSms',
  SendCheckInSms: BaseUrl + 'AppLink/SendCheckInSms',

  //RolesRights
  GetRoles: BaseUrl + 'RolesRights/GetRoles',
  GetRoleDetails: BaseUrl + 'RolesRights/GetRoleDetails',
  UpdateRoleDetails: BaseUrl + 'RolesRights/Update',
  GetFeature: BaseUrl + 'RolesRights/GetFeature',
  UpdateFeature: BaseUrl + 'RolesRights/UpdateFeature',
  GetRolesToAddUser: BaseUrl + 'RolesRights/GetRolesToAddUser',
  GetEmployee: BaseUrl + 'Reception/Get',
  AddRole: BaseUrl + 'RolesRights/AddRole',
  GetApplicationList: BaseUrl + 'RolesRights/GetApplicationList',
  UpdateStampInFeature: BaseUrl + 'RolesRights/UpdateStampInFeature',

  //DealerNotificationLog
  GetNotificationTypes: BaseUrl + 'DealerNotificationLog/GetNotificationTypes',
  GetFilteredNotifications: BaseUrl + 'DealerNotificationLog/Filter',
  ReadNotificationById: BaseUrl + 'DealerNotificationLog/Read',
  SentSarboxInformation: BaseUrl + 'Notification/SendShareBoxInformation',
  //Brand
  GetBrands: BaseUrl + 'Brand/Get',
  AddBrand: BaseUrl + 'Brand/Add',
  DeleteBrand: BaseUrl + 'Brand/DeleteBrand',
  GetBrandById: BaseUrl + 'Brand/GetById',
  EditBrand: BaseUrl + 'Brand/Update',
  GetCompetenceByBrandId: BaseUrl + 'Brand/GetCompetenceByBrandId',
  GetBrandDropdownList: BaseUrl + 'Brand/GetDropdownList',
  GetModelnoDropdownList: BaseUrl + 'Modelno/GetDropdownList',
  GetBrandsByCompetence: BaseUrl + 'Brand/GetBrandsByCompetence',
  GetServiceBrandDropdownList :BaseUrl + 'Brand/GetServiceBrandDropdownList',
  //Competence
  GetCompetence: BaseUrl + 'Competence/Get',
  AddCompetence: BaseUrl + 'Competence/Add',
  DeleteCompetence: BaseUrl + 'Competence/Delete',
  GetCompetenceById: BaseUrl + 'Competence/GetById',
  EditCompetence: BaseUrl + 'Competence/Update',

  //Service Advisor
  GetServiceAdvisorDetails: BaseUrl + 'ServiceAdvisor/GetServiceAdvisorDetails',

  //Campaign Services
  TargetedGroup: EnvSetting.CAMPAIGN_BASE_API_URL + 'targetedgroups',
  CampaignMember: EnvSetting.CAMPAIGN_BASE_API_URL + 'campaignmembers',
  Campaign: EnvSetting.CAMPAIGN_BASE_API_URL + 'campaigns',
  Template: EnvSetting.CAMPAIGN_BASE_API_URL + 'templates',

  GetApplicationSource: BaseUrl + 'ApplicationSource/Get',

  //SSM
  ExportSSM: BaseUrl + 'SuperServiceMenu/Export',
  ImportSSM: BaseUrl + 'SuperServiceMenu/Import',
  DeleteSSM: BaseUrl + 'SuperServiceMenu/Delete',

  //User Vise Appointment list
  GetUserViseAppointmentList : BaseUrl + 'Report/GetUserViseAppointment',

  //Cdss Appointment list
  GetCdssAppointmentList : BaseUrl + 'Report/GetCdssUserAppointment',

  //Customer Waiting List
  GetCustomerWaitingList: BaseUrl + 'Report/Get',

  //Deleted Planning List
  GetDeletedPlanning: BaseUrl + 'Report/GetDeletedPlanning',

  //Vehicle Pick Drop List
  GetVehiclePickDropList : BaseUrl + 'Report/GetVehiclePickDropReportList',
  //Customer Pick Drop List
  GetCustomerPickDropList : BaseUrl + 'Report/GetCustomerPickDropReportList',
  GetContactUserList:BaseUrl + 'Report/GetContactUserList',
  GetCheckInUsageDealerList: BaseUrl + 'Report/GetCheckInUsageDealerList',
  GetCheckInUsageDealerWiseAppointmentList: BaseUrl + 'Report/GetCheckInUsageDealerWiseAppointmentList',
  GetCheckinTraversalList:BaseUrl + 'Report/GetCheckinTraversalList',
  
  GetNotifications: `${BaseUrl}Dashboard/GetNotifications`,
  NotificationMarkAllAsRead: `${BaseUrl}Dashboard/NotificationsMarkAllAsRead`,
  NotificationMarkAsRead: `${BaseUrl}Dashboard/NotificationsMarkAsRead`,

  //Application Version
  GetApplicationVersionList: BaseUrl + 'ApplicationVersion/Get',
  GetVersionNumberList: BaseUrl + 'ApplicationVersion/GetVersionNumberList',
  AddApplicationVersion: BaseUrl + 'ApplicationVersion/Add',
  GetApplicationVersionById: BaseUrl + 'ApplicationVersion/GetById',
  EditApplicationVersion: BaseUrl + 'ApplicationVersion/Edit',

  //Accounts
  GetAccountsList: BaseUrl + 'Accounts/Get',
  GetAccountDetailsById: BaseUrl + 'Accounts/GetById',
  GetContactDetailsById: BaseUrl + 'Accounts/GetUsersById',

  //Labor
  GetLaborList: BaseUrl + 'Labor/Get',
  GetLaborById: BaseUrl + 'Labor/GetById',
  AddUpdateLabor: BaseUrl + 'Labor/AddEdit',
  RysyncLabor: BaseUrl + 'Labor/ResyncLabor',

  GetSearchLabor: BaseUrl + 'Labor/GetBySearch',
  GetChargingGroupDropDownList: BaseUrl + 'Labor/GetChargingGroupDropDownList',

  //WarningLight
  AddUpdateWarningLight: BaseUrl + 'WarningLight/AddEdit',
  GetWarningLightList: BaseUrl + 'WarningLight/Get',
  GetWarningLightById: BaseUrl + 'WarningLight/GetById',
  DeleteWarningLight: BaseUrl + 'WarningLight/Delete',
  GetWarningLightDropdown: BaseUrl + 'Services/GetWarningLightDropdown',

  //TecRMI
  VehicleHasProposal: BaseUrl + 'TecRMI/VehicleHasProposal',
  GetGearBoxList: BaseUrl + 'TecRMI/GetGearBoxList',
  VehicleHasServiceProposal: BaseUrl + 'TecRMI/VehicleHasServiceProposal',
  GetCooGroupList: BaseUrl + 'TecRMI/GetCooGroupsForMaintenance',
  GetVehicleMaitananceWorkList: BaseUrl + 'TecRMI/GetMaintenanceWorks',
  GetVehicleServiceProposal: BaseUrl + 'TecRMI/GetServiceProposal',
  GetPartsForWork: BaseUrl + 'TecRMI/GetPartsForWork',
  UpdateTecDocIds: BaseUrl + 'TecRMI/UpdateTecDocIds',

  GetLabourWorkList: BaseUrl + 'TecRMI/GetLabourWorkList',
  GetWorkStepsByItemMpId: BaseUrl + 'TecRMI/GetWorkStepsByItemMpId',

  //PaymentMaster
  GetPaymentMethod: BaseUrl + 'PaymentMaster/paymentMethodDropdown',
  GetPaymentTerm: BaseUrl + 'PaymentMaster/paymentTermsDropdown',
  GetReminderTerm: BaseUrl + 'PaymentMaster/reminderTermsDropdown',
  GetLaborAndSalesPriceGroup: BaseUrl + 'PaymentMaster/laborAndSalesPriceGroupDropdown',

  //Appointment Locking
  GetLockedAppointments : BaseUrl + 'AppointmentLock/GetLockedAppointments',
  UnlockAppointment : BaseUrl + 'AppointmentLock/UnlockAppointments',
  IsLockedByOtherUser : BaseUrl + 'AppointmentLock/IsLockedByOtherUser',

  //Mechanic efficiency
  GetMechanicEfficiencyReport: BaseUrl + 'Report/GetMechanicEfficiency',
  GetMechanicAccuracyReport: BaseUrl + 'Report/GetMechanicAccuracy',

  //Mechanic Report
  GetMechanicReport:BaseUrl+'Report/GetMechanicReport',
  //Mechanic Report
  GetTimeStampReport:BaseUrl+'Report/GetTimeStampReport',
  GetTimeStampDetails:BaseUrl+'Report/GetTimeStampDetails',
  GetMechanicWorkTimeStampList:BaseUrl+'Report/GetMechanicWorkTimeStampList',
  //Service - Mechanic wise Report
  GetServiceMechanicWiseReport:BaseUrl+'Report/GetServiceMechanicWiseReport',

  // Mechanic - Total Sold Hours Report
  GetTotalSoldHoursReport: BaseUrl + 'Report/GetTotalSoldHoursReport',

  //Action Type Configuration
  GetActionTypeList : BaseUrl + 'ActionType/GetList',
  UpdateActionType : BaseUrl + 'ActionType/Update',
  
  //Automatic Updates
  AutomaticUpdatesList : BaseUrl + 'AutomaticUpdates/List',
  AutomaticUpdatesSave : BaseUrl + 'AutomaticUpdates/Update',

  //Kaha
  GetAvailableStock : BaseUrl + 'Kaha/GetAvailableStock',
  CreateArticlePurchaseOrder : BaseUrl + 'Kaha/CreateArticlePurchaseOrder',

  //Romnas
  GetRomnasAutoLoginUrl: BaseUrl + 'Romnas/GetAutoLoginURL',
  ImportRomnasBasket: BaseUrl + 'Romnas/ExportPartsBasket',
  DeleteRomnas: BaseUrl + 'Romnas/Delete',

  //Agent Efficiency Report
  GetDealerWiseAgentList: BaseUrl + 'Report/GetDealerWiseAgentList',
  GetAgentDetailsList: BaseUrl + 'Report/GetAgentDetailsList',

  //Call Dealer Logs
  GetCallDealerLogs: BaseUrl + 'Report/GetCallDealerLogs',
  GetDealerWiseCallHistory: BaseUrl + 'Report/GetDealerWiseCallHistory',
  
  // Work Order Details
  GetWorkOrderDetailsReport: BaseUrl + 'Report/GetWorkOrderDetailsReport',

  //Towe In User
  GetToweInUsageList: BaseUrl + 'Report/GetToweInUsageList',
  GetToweInUsageDealerWiseList: BaseUrl + 'Report/GetToweInUsageDealerWiseList',

  // Additional Work List
  GetAdditionalWorkList: BaseUrl + 'Report/GetAdditionalWorkList',

  //Invocie
  GetDocumentWarningByWo: BaseUrl + 'Invoice/GetInvoiceWarningByWo',
  GenerateInvoice: BaseUrl + 'Invoice/GenerateInvoice',
  GetPostedInvoiceByWo: BaseUrl + 'Invoice/GetPostedInvoiceByWo',
  GetInvoiceDocuments: BaseUrl + 'Invoice/GetInvoiceDocuments',
  GetInvoicePreview: BaseUrl + 'Invoice/GetInvoicePreview',

  //WhatsApp Log
  SendWhatsAppMessage: BaseUrl + 'WhatsAppLog/SendWhatsAppMessage',
  GetWhatsAppMessages: BaseUrl + 'WhatsAppLog/GetWhatsAppMessages',
  GetUnrepliedWhatsAppMessages: BaseUrl + 'WhatsAppLog/GetUnrepliedWhatsAppMessages',

  //User Clock In Out
  GetUserClockInOut: BaseUrl + 'UserStampInOut/Get',
  RegisterUserStamp: BaseUrl + 'UserStampInOut/RegisterUserStamp',
  GetUserForClocking: BaseUrl + 'UserStampInOut/GetUsers',
  GetUserStampReport: BaseUrl + 'UserStampInOut/Getreport',
    GetLocationCodeName: BaseUrl + 'UserStampInOut/GetLocationCodeName',

    //MPO
    CreateOffer: BaseUrl + 'MenuPrice/CreateOffer',
    GetOffer: BaseUrl + 'MenuPrice/GetOffer',
}
